var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rule-form')
}
var staticRenderFns = []

export { render, staticRenderFns }